import React, { useRef } from 'react';
import { Group, Line, Text, Circle } from 'react-konva';
import { deriveRoomGeometry, isElectricityValid } from '../dataModels';
import { useApp } from 'stateMgmt/AppContext';
import { actions } from 'stateMgmt/actions';
import { WallRenderer } from './WallRenderer';

// Draw everything in meters - scale is applied at parent Group level
export function RoomRenderer({ room }) {
  const { selectedRoomId, setSelectedRoomId, dispatch, ui: { gridSize } } = useApp();
  const isSelected = selectedRoomId === room.id;
  const dragTargetRef = useRef(null);

  const { centerX, centerY, area, boundingBox } = deriveRoomGeometry(room.walls);
  const isElectricityValidResult = isElectricityValid(room);

  const selectRoom = (e) => {
    console.log('selectRoom', room.id);
    if (e) e.cancelBubble = true;
    setSelectedRoomId(room.id);
  };

  const handleDragStart = (e) => {
    // Prevent canvas panning when dragging a room
    e.cancelBubble = true;
  };

  const handleDragEnd = (e) => {
    const node = e.target;

    // Raw delta in world units (meters)
    const dx = node.x();
    const dy = node.y();

    // Reset visual transform (critical)
    node.position({ x: 0, y: 0 });

    // Snap delta to grid
    const grid = gridSize || 0.5; // meters
    const snap = (v) => Math.round(v / grid) * grid;

    const dxSnapped = snap(dx);
    const dySnapped = snap(dy);

    // If snapping removed all movement, do nothing
    if (!dxSnapped && !dySnapped) return;

    dispatch({
      type: actions.UPDATE_ROOM_POSITION,
      payload: {
        room: room,
        position: { dx: dxSnapped, dy: dySnapped }
      }
    });
  };
  return (
    <Group>
      {/* Invisible hit polygon for drag/select (AABB). Replace with true polygon later. */}
      {boundingBox.length > 0 && (
        <Line
          ref={dragTargetRef}
          points={boundingBox}
          closed
          fill="transparent"
          stroke="transparent"
          hitStrokeWidth={0.5} // easier to grab (meters)
          draggable
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
          onClick={selectRoom}
          onTap={selectRoom}
        />
      )}

      {/* Walls */}
      {room.walls.map(wall => <WallRenderer key={wall.id} wall={wall} roomCenter={{ x: centerX, y: centerY }} />)}


      {/* Classification */}
      {room.classification && (
        <Text
          x={centerX - 1.5}     // half of labelWidth
          y={centerY - 0.25}
          width={3}             // meters (enough for text)
          text={room.classification}
          fontSize={0.10}
          fill="#555"
          align="center"
          listening={false}
        />
      )}
      {/* Electricity validation error indicator */}
      {!isElectricityValidResult && (
        <>
          {/* Red circle background */}
          <Circle
            x={centerX}
            y={centerY - 0.50}   // top-center inside room
            radius={0.18}        // 18cm radius
            fill="#F44336"       // material red
            listening={false}
          />

          {/* Bold X */}
          <Text
            x={centerX - 0.18}
            y={centerY - 0.65}
            width={0.36}         // match diameter
            text="✕"
            fontSize={0.30}      // big, bold
            fontStyle="bold"
            fill="#FFFFFF"
            align="center"
            listening={false}
          />
        </>
      )}
      <Text
        x={centerX - 0.08}
        y={centerY - 0.08}
        text={room.number?.toString() || ''}
        fontSize={0.12}
        fill={isSelected ? '#fff' : '#333'}
        onClick={selectRoom}
        onTap={selectRoom}
      />

      {area > 0 && (
        <Text
          x={centerX - 0.30}
          y={centerY + 0.20}
          text={`${area.toFixed(2)} m²`}
          fontSize={0.10}
          fill="#666"
          listening={false}
        />
      )}
    </Group>
  );
}

